/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo } from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { useIntl } from "react-intl";
import { AELink } from "../../../_emywork/components/AELink";
import { AESVG } from "../../../_emywork/components/svg";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../Dashboard/_redux/actions";
import { AECurrency, toCurrency } from "../../../_emywork/components/Currency";
import { useHtmlClassService } from "../../../_metronic/layout";
import objectPath from "object-path";
import ApexCharts from "apexcharts";
import moment from "moment";

import fr from "apexcharts/dist/locales/fr.json";
import en from "apexcharts/dist/locales/en.json";
import es from "apexcharts/dist/locales/es.json";
import { getConfig } from "../../../_metronic/i18n";
const ar = {
  name: "ar",
  options: {
    months: [
      "يناير",
      "فبراير",
      "مارس",
      "أبريل",
      "يمكن",
      "يونيو",
      "تموز",
      "أغسطس",
      "سبتمبر",
      "اكتوبر",
      "نوفمبر",
      "ديسمبر",
    ],
    shortMonths: [
      "يناير",
      "فبراير",
      "مارس",
      "أبريل",
      "يمكن",
      "يونيو",
      "تموز",
      "أغسطس",
      "سبتمبر",
      "اكتوبر",
      "نوفمبر",
      "ديسمبر",
    ],
    days: [
      "الأحد",
      "الاثنين",
      "الثلاثاء",
      "الأربعاء",
      "الخميس",
      "جمعة",
      "السبت",
    ],
    shortDays: [
      "الأحد",
      "الاثنين",
      "الثلاثاء",
      "الأربعاء",
      "الخميس",
      "جمعة",
      "السبت",
    ],
    toolbar: {
      exportToSVG: "تحميل SVG",
      exportToPNG: "تحميل PNG",
      exportToCSV: "تحميل CSV",
      menu: "قائمة",
      selection: "اختيار",
      selectionZoom: "تكبير التحديد",
      zoomIn: "تكبير",
      zoomOut: "تصغير",
      pan: "نقل",
      reset: "إعادة تعيين التكبير",
    },
  },
};

export function WalletWidget({ withChart, className }) {
  const dispatch = useDispatch();
  const { rtl, selectedLang } = getConfig();
  const { formatMessage } = useIntl();
  const wallet = useSelector(({ statistics }) => statistics.wallet);
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      colorsGrayGray500: objectPath.get(
        uiService.config,
        "js.colors.gray.gray500"
      ),
      colorsGrayGray300: objectPath.get(
        uiService.config,
        "js.colors.gray.gray300"
      ),
      colorsThemeBaseColor: objectPath.get(
        uiService.config,
        `js.colors.theme.base.primary`
      ),
      colorsThemeLightColor: objectPath.get(
        uiService.config,
        `js.colors.theme.light.primary`
      ),
      fontFamily: objectPath.get(uiService.config, "js.fontFamily"),
    };
  }, [uiService]);

  useEffect(() => {
    const element = document.getElementById("kt_tiles_widget_1_chart");

    if (!element) {
      return;
    }

    const dataTransactions = wallet.transactions.map((t) => ({
      x: moment(t.created_at).format("LLLL"),
      y: parseInt(t.amount),
    }));

    let options = {
      series: [
        {
          name: "Transaction",
          data: dataTransactions,
        },
      ],
      chart: {
        type: "area",
        locales: [ar, en, es, fr],
        defaultLocale: selectedLang,
        height: 350,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        show: true,
        width: 3,
        colors: [layoutProps.colorsThemeBaseColor],
      },

      title: {
        text: "Transactions",
        align: "left",
        style: {
          fontSize: "14px",
        },
      },
      xaxis: {
        type: "datetime",
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        tickAmount: 4,
        floating: false,

        labels: {
          style: {
            colors: "#8e8da4",
          },
          offsetY: -7,
          offsetX: 0,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      fill: {
        opacity: 0.5,
      },
      tooltip: {
        x: {
          formatter: (val) => {
            return moment(val).format("LLLL");
          },
        },
        y: {
          formatter: (val) => {
            return toCurrency(val);
          },
        },
        fixed: {
          enabled: false,
          position: "topRight",
        },
      },
      grid: {
        yaxis: {
          lines: {
            offsetX: -30,
          },
        },
        padding: {
          left: 20,
          right: 0,
        },
      },
      colors: [layoutProps.colorsThemeLightColor],
      markers: {
        colors: [layoutProps.colorsThemeLightColor],
        strokeColor: [layoutProps.colorsThemeBaseColor],
        strokeWidth: 3,
      },
    };
    //FIX: empty wallet case, display a simple message
    const chart = new ApexCharts(element, options);
    if (wallet.transactions.length > 0) {
      chart.render();
    }
    // else {
    //   element.innerHTML = "<strong>No transactions yet!</strong>";
    // }
    // console.log({ chart, wallet });
    return function cleanUp() {
      if (wallet.transactions.length > 0) chart.destroy();
    };
  }, [layoutProps, wallet]);

  return (
    <>
      <div
        className={`card card-custom bgi-no-repeat gutter-b ${className}`}
        style={{
          // height: '150px',
          backgroundPosition: "right top",
          backgroundSize: "20% auto",
          // backgroundImage: `url('${toAbsoluteUrl('/media/svg/shapes/abstract-1.svg')}')`,
        }}
      >
        <div className="card-body">
          <div
            className={`d-flex align-items-center justify-content-between ${
              withChart ? "gutter-b" : ""
            }`}
          >
            <AESVG
              size={"3x"}
              variant={`primary`}
              // className={'ml-n2'}
              path={"/Shopping/Wallet.svg"}
            />
            <div className="d-flex flex-column text-right">
              <span className="text-dark-75 font-weight-bolder font-size-h3">
                <AECurrency value={wallet.balance} />
              </span>
              <span className="text-muted font-weight-bold mt-2">
                {formatMessage({ id: "WALLET_BALANCE" })}
              </span>
            </div>
          </div>
          {!rtl && //RTL is not supported
            withChart && (
              <div
                id="kt_tiles_widget_1_chart"
                data-color={"primary"}
                direction="ltr"
                dir="ltr"
                style={{ direction: "ltr" }}
                // style={{ height: "150px" }}
              />
            )}
        </div>
      </div>
    </>
  );
}
